import { Controller } from "@hotwired/stimulus"

// L'identificativo dell'operazione del registro delle richieste di erogazione (run() di components/RichiesteErogazione.js,
// 31a5bd1): ogni scrittura porta un `operazione_id` = crypto.randomUUID() che resta lo stesso, per lo stesso modulo e gli
// stessi dati, finche' la scrittura non riesce (ops.current: Map chiave -> uuid, cancellata a risposta riuscita). Cosi' un
// «Riprova» dopo un errore o una risposta persa e' la stessa operazione, non una seconda (idempotenza del server). La
// chiave e' l'indirizzo del modulo piu' i campi scritti (senza token, revisione e identificativo); la memoria e' sessionStorage,
// con una Map se non c'e'. Durante l'invio i moduli sono spenti e compare «Operazione in corso…» (busy).
//   <div data-controller="operazione" data-action="submit->operazione#prepara turbo:submit-start->operazione#occupato
//        turbo:before-fetch-response->operazione#risposta"> <p data-operazione-target="attesa" hidden>…</p>
//        <fieldset data-operazione-target="campi"> <form action="…"><input type="hidden" name="operazione_id"> …
const PREFISSO = "erogo:operazione:"
const ESCLUSI = ["authenticity_token", "operazione_id", "revisione", "_method"]
const memoria = new Map()

function leggi(chiave) {
  try { return window.sessionStorage.getItem(PREFISSO + chiave) } catch { return memoria.get(chiave) || null }
}
function scrivi(chiave, valore) {
  memoria.set(chiave, valore)
  try { window.sessionStorage.setItem(PREFISSO + chiave, valore) } catch { /* senza sessionStorage resta la Map */ }
}
function togli(chiave) {
  memoria.delete(chiave)
  try { window.sessionStorage.removeItem(PREFISSO + chiave) } catch { /* idem */ }
}
function chiaveDi(form) {
  const campi = []
  for (const [nome, valore] of new FormData(form).entries()) {
    if (!ESCLUSI.includes(nome) && typeof valore === "string") campi.push([nome, valore])
  }
  return new URL(form.action, window.location.href).pathname + JSON.stringify(campi)
}

export default class extends Controller {
  static targets = ["attesa", "campi"]

  prepara(event) {
    const form = event.target
    const campo = form.elements?.operazione_id
    if (!campo) return
    const chiave = chiaveDi(form)
    let uuid = leggi(chiave)
    if (!uuid) {
      uuid = crypto.randomUUID()
      scrivi(chiave, uuid)
    }
    campo.value = uuid
  }

  occupato(event) {
    if (event.target.elements?.operazione_id === undefined) return
    if (this.hasAttesaTarget) this.attesaTarget.hidden = false
    // i dati del form sono gia' letti: spegnere i campi non li toglie dalla richiesta
    if (this.hasCampiTarget) this.campiTarget.disabled = true
  }

  // Risposta riuscita (2xx): l'operazione e' conclusa, la prossima con gli stessi dati e' un'altra. Un errore la conserva.
  risposta(event) {
    const form = event.target
    if (form.elements?.operazione_id === undefined) return
    if (event.detail.fetchResponse?.succeeded) togli(chiaveDi(form))
  }
}
